import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const sendMail = createAsyncThunk(
    'partsales/sendmail',
    async (mailparams) => {
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/sendmail`, 
            mailparams,
        ).catch((err) => {
            return {'status': 500, 'data': 'failed'}
        });
        return { 'status': response.status, 'data': response.data }
    }
)
